import { v4 as uuid } from 'uuid';
import { getCookieValue } from '../getCookieValue';

export async function hashDeviceID(deviceId: string) {
  const msgBuffer = new TextEncoder().encode(deviceId);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer as BufferSource);
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

export const getDeviceId = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return uuid();
  }
  const deviceId = getCookieValue('cookie_id');

  return deviceId ?? '';
};

export const getDeviceIdWithoutHmac = (defaultValue = uuid()) => {
  const deviceId = getDeviceId();
  return deviceId.length > 0
    ? deviceId.slice(deviceId.length - 36)
    : defaultValue.slice(defaultValue.length - 36);
};
